export const SITE = {
    name: "Pocketfolio",
    domain: "pocketfolio.ai",
    email: "contact@pocketfolio.ai",
    address: ["Bonovo Road – Fomboni", "Island of Mohéli", "Comoros Union"],
};

export const IMAGES = {
    heroGold: "/images/hero-trading.jpg",
    goldSphere: "https://images.pexels.com/photos/31650383/pexels-photo-31650383.jpeg?auto=compress&cs=tinysrgb&w=1600",
    chartDark: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=1600&q=80",
    chartDark2: "https://images.unsplash.com/photo-1689732888407-310424e3a372?auto=format&fit=crop&w=1600&q=80",
    monitorGraphs: "https://images.pexels.com/photos/159888/pexels-photo-159888.jpeg?auto=compress&cs=tinysrgb&w=1600",
    office: "https://images.pexels.com/photos/28506813/pexels-photo-28506813.jpeg?auto=compress&cs=tinysrgb&w=1600",
    desk: "https://images.unsplash.com/photo-1510519138101-570d1dca3d66?auto=format&fit=crop&w=1600&q=80",
};

export const INTERESTS = [
    "Forex Trading Bots",
    "Forex Signals",
    "Trading Education",
    "Partnership",
    "General Enquiry",
];

export const SERVICES = [
    {
        id: "bots",
        name: "Forex Trading Bots",
        tagline: "Rules-based execution, around the clock.",
        description:
            "Institutional-grade expert advisors engineered for gold, crude oil and major index markets. Every strategy is backtested across multiple market regimes, walk-forward validated, and deployed with hard drawdown limits.",
        features: [
            "MT4 / MT5 compatible expert advisors",
            "Multi-year backtests with walk-forward validation",
            "Built-in equity stops and max drawdown caps",
            "Optimised for XAU/USD, WTI crude and index CFDs",
            "VPS-ready with 24/5 unattended execution",
        ],
        image: IMAGES.chartDark,
    },
    {
        id: "signals",
        name: "Forex Signals",
        tagline: "High-conviction setups, delivered with discipline.",
        description:
            "A research desk that filters noise down to a handful of structured setups each week across commodities, indices and ETFs. Every signal ships with entry, stop-loss, targets and the reasoning behind the trade.",
        features: [
            "5–10 curated setups per week",
            "Entry, stop-loss and take-profit on every call",
            "Commodities, stock indices and ETF coverage",
            "Full trade rationale with chart context",
            "Performance reported with drawdown, not just wins",
        ],
        image: IMAGES.monitorGraphs,
    },
    {
        id: "education",
        name: "Trading Education",
        tagline: "From curious to consistently process-driven.",
        description:
            "A structured curriculum that takes traders from market foundations to risk-managed, strategy-led execution. Live sessions, playbooks and mentoring built by operators who trade what they teach.",
        features: [
            "Structured curriculum: foundations to advanced strategy",
            "Risk management and position-sizing masterclasses",
            "Live market webinars and trade reviews",
            "Strategy playbooks for gold, oil and indices",
            "Mentorship from active desk traders",
        ],
        image: IMAGES.desk,
    },
];

export const MANIFESTO = [
    {
        n: "01",
        title: "Precision",
        copy: "Markets reward discipline and punish improvisation. Our algorithms execute the same rigorously tested logic on every tick — no hesitation, no fatigue, no revenge trades.",
    },
    {
        n: "02",
        title: "Conviction",
        copy: "A signal is only worth sending when the structure behind it is clear. We would rather publish five high-conviction setups a week than fifty shots in the dark.",
    },
    {
        n: "03",
        title: "Mastery",
        copy: "Tools amplify skill; they never replace it. Our education desk exists so that every client understands exactly what their capital is doing and why.",
    },
    {
        n: "04",
        title: "Accountability",
        copy: "We are a registered company with a published address, a reachable desk, and performance language that includes drawdown. Trust is a position we never close.",
    },
];
